var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 17
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16 14h-2V7h-3v7H9V7H6v7H4V7H2.812a2.1 2.1 0 0 1-.509-4.137L10 .938l7.697 1.925A2.1 2.1 0 0 1 17.187 7H16zM10 3 2.788 4.803A.1.1 0 0 0 2.812 5h14.376a.1.1 0 0 0 .024-.197zM2 15h16a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2"
})));
export default SvgIconBank;